// POST - Create a new task
export const POST_TASK = `/easeetask/task`;

// GET - Search and list tasks
export const GET_TASKS_LIST_SEARCH = `/easeetask/tasks/list/search`;
// GET - Search and list archived tasks
export const GET_ARCHIVED_TASKS_LIST_SEARCH = `/easeetask/archived_tasks/list/search`;

// POST - Add observation/update to a task
export const POST_TASK_OBSERVATION = (taskID) => `/easeetask/task/${taskID}/add-observation`;

// GET - Get task history/updates
export const GET_TASK_HISTORY = (taskID, desc = 'desc') => `/easeetask/task/${taskID}/${desc}/history`;

// PUT - Update task accomplished value
export const UPDATE_TASK_ACCOMPLISHED = (serviceProvider, taskID, userID) => `/easeetask/task/update/${serviceProvider}/${taskID}/${userID}`;
// PUT - Update task (mobile endpoint - for notifiers, etc.)
export const UPDATE_TASK_MOBILE = (serviceProvider, taskID, userID) => `/easeetask/task/update/${serviceProvider}/${taskID}/${userID}`;

// PUT - Archive tasks (no /mobile prefix)
export const ARCHIVE_TASKS = (userID) => `/easeetask/task/archive/${userID}`;
export const UNARCHIVE_TASKS = (userID) => `/easeetask/task/unarchive/${userID}`;
export const DELETE_TASKS = (userID) => `/easeetask/delete-tasks/${userID}`;
// POST - Upload files for task
export const UPLOAD_TASK_FILES = (serviceProvider, projectID, userID) => `/easeetask/upload/files/${serviceProvider}/${projectID}/${userID}`;

// PUT - Update task assignee/owner
export const UPDATE_TASK_ASSIGNEE = (serviceProvider, taskID, userID) => `/easeetask/task/assign/${serviceProvider}/${taskID}/${userID}`;

// POST - Send email from task
export const POST_EMAIL_FROM_TASK = (taskID) => `/easeetask/email_from_task/${taskID}`;

// GET - Get tags for a task
export const GET_TASK_TAGS = (serviceProvider, userID) => `/mobile/tags/${serviceProvider}/${userID}`;

// POST - Create a new tag
export const POST_ADD_TAG = `/easeetask/add-tag`;

// DELETE - Delete tags
export const DELETE_TAGS = `/easeetask/delete-tags`;

// GET - Get received tasks for a user
export const GET_RECEIVED_TASKS = (userID) => `/easeetask/received-tasks/${userID}`;

// GET - Get sent tasks for a user
export const GET_SENT_TASKS = (userID) => `/easeetask/sent-tasks/${userID}`;

// GET - Get assignee list for an organisation
export const GET_ASSIGNEE_LIST = (organisationID) => `/easeetask/assignee-list/${organisationID}`;

// GET - Get assignee permissions for an organisation
export const GET_ASSIGNEE_PERMISSIONS = (organisationID) => `/easeetask/assignee/${organisationID}`;

// GET - Get day-off requests for an organisation
export const GET_REQUEST_DAY_OFF = (organisationID) => `/easeetask/request_day_off/${organisationID}`;

// GET - Get user time-off details (settings)
export const GET_USER_TIME_OFF = (organisationID) => `/easeetask/settings/${organisationID}`;

// GET - Get owners for an organisation
export const GET_OWNERS = (organisationID) => `/easeetask/owners/${organisationID}`;

// GET - Get notifiers for an organisation (new unified format)
export const GET_NOTIFIERS = (organisationID) => `/easeetask/notifiers/${organisationID}`;

// POST - Create summary (Start activity)
export const POST_START_ACTIVITY = `/easeetask/create-summary`;

// PUT - Update summary (End activity)
export const PUT_UPDATE_SUMMARY = `/easeetask/update-summary`;

// POST - Create Pomodoro timer
export const POST_CREATE_POMODORO_TIMER = (projectID) => `/easeetask/create-pomodoro/timer/${projectID}`;

// PUT - End Pomodoro timer
export const PUT_END_POMODORO_TIMER = (projectID) => `/easeetask/end-pomodoro/timer/${projectID}`;

// POST - Update total time spent
export const POST_UPDATE_TIME_SPENT = (taskID) => `/easeetask/project_time/time_spent/${taskID}`;

// GET - Get summary
export const GET_SUMMARY = `/easeetask/get-summary`;

// GET - Get summary history
export const GET_SUMMARY_HISTORY = `/easeetask/get-summary-history`;

// DELETE - Remove / cancel day off request
export const DELETE_REMOVE_DAY_OFF = (dayoffID) => `/mobile/dailee/remove-userDaysOff/${dayoffID}`;

// POST - Approve day off request
export const POST_APPROVE_DAY_OFF = (dayoffID) => `/mobile/approve_day_off/${dayoffID}`;

// POST - Decline day off request
export const POST_DECLINE_DAY_OFF = (dayoffID) => `/mobile/decline_day_off/${dayoffID}`;

// PUT - Mark day off approved
export const PUT_MARK_DAY_OFF_APPROVED = (dayoffID) => `/easeetask/mark_day_off_approved/${dayoffID}`;

// PUT - Update member management info (days off left, etc.)
export const PUT_UPDATE_MANAGEMENT_INFO = (orgId, userId) => `/mobile/user/update_management_info/${orgId}/${userId}`;

// GET - Get user events (days-off change history)
export const GET_USER_EVENTS = (userId) => `/mobile/dailee/events/${userId}`;

// PUT - Update organisation standard working hours
export const PUT_UPDATE_STANDARD_HOUR = (orgId) => `/mobile/user/update-organisation-standard-hour/${orgId}`;

// Legacy routes (kept for backward compatibility)
export const ADD_PROJECT = `/easeetask/task`;
export const ADD_FORM = `/task/add-form/59/`;
